import { formBodyString } from '@/lib/login/form-body';

export interface LoginData {
  email: string;
  password: string;
}

export const fetchLogin = (loginData: LoginData): Promise<Response> => {
  const body = formBodyString({
    username: loginData.email,
    password: loginData.password,
  });

  return fetch('/api/auth/login', {
    method: 'POST',
    body,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      accept: 'application/json',
    },
  });
};
